import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

// TODO: Make a task to use the to-cm-date function
@Pipe({
    name: 'cmDate',
    standalone: false
})
export class CmDatePipe implements PipeTransform {
	constructor() {}

	transform(value: any, format?: string, timezone?: string): string {
		const dateString = Date.parse(value);
		if (!dateString) {
			return '';
		}
		if (!format) {
			format = 'yyyy-MM-dd';
		}
		return formatDate(dateString, format, 'en', timezone ? timezone : undefined);
	}
}
